import React, { useState } from "react";
import GoogleIcon from "../../../css/images/icon-google.svg";
import { Link } from "react-router-dom";
import Features from "./Features";

const Login = ({ googleSignIn, emailLogin }) => {
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");

	const handleSignup = (event) => {
		event.preventDefault();
		// Handle signup form submission
		console.log("Signup form submitted:", { firstName, lastName, email, password });
		emailLogin(email, password);
	};

	return (
		<div className="signup-container">
			<div className="form-container">
				<h1 className="signup-title">Log in</h1>
				<form onSubmit={handleSignup} className="signup-form">
					<div className="input-group">
						<label className="signup-label">Email:</label>
						<input type="email" value={email} onChange={(event) => setEmail(event.target.value)} className="signup-input" />
					</div>
					<div className="input-group">
						<label className="signup-label">Password:</label>
						<input type="password" value={password} onChange={(event) => setPassword(event.target.value)} className="signup-input" />
					</div>
					<button type="submit" className="signup-button">
						Login
					</button>
				</form>
				<div className="sep-wrp">
					<h3 className="sep-title">OR</h3>
				</div>
				<div className="google-login-container">
					<button className="btn btn-google-login" onClick={() => googleSignIn()}>
						<span className="ico">
							<img src={GoogleIcon} className="icon-google" alt="icon-google" />
						</span>
						<span className="txt">Log in with Google</span>
					</button>
				</div>
				<div className="toggle-login">
					Want to make an account?
					<Link to="/signup" className="login-link">
						Sign Up
					</Link>
				</div>
			</div>
			<div className="info-container-right">
				<Features />
			</div>
		</div>
	);
};

export default Login;
